import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import AdminNavbar from '../components/Navbar/AdminNavbar';
import AdminSidebar from '../components/Sidebar/AdminSidebar';
import Sidebar from '../components/Sidebar/Sidebar';
import { getRole } from '../components/Apicall';
import './Layout.css';

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const role = getRole();
    setUserRole(role);
  }, []);

  const renderSidebar = () => (
    userRole === '3' ? <Sidebar /> : <AdminSidebar />
  );

  const renderNavbar = () => (
    userRole === '3' ? <Navbar toggleSidebar={toggleSidebar} /> : <AdminNavbar toggleSidebar={toggleSidebar} />
  );

  return (
    <div className="layout-container">
      {renderNavbar()}
      <div className="d-flex">
        <div className={`sidebar-wrapper ${isSidebarOpen ? 'show' : ''}`}>
          {renderSidebar()}
          <div className="sidebar-backdrop d-lg-none" onClick={toggleSidebar}></div>
        </div>
        <main className={`content-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout; 
